// // src/pages/modules/ExpenseCollectionReportPage.jsx

// import React, { useEffect, useState, useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   fetchExpenseCollectionReport,
//   exportExpenseCollectionReport,
//   clearError,
// } from 'store/slices/reportSlice';

// import PageHeader from 'components/common/PageHeader';
// import { Card, CardHeader, CardTitle, CardContent } from 'components/ui/card';
// import { Badge } from 'components/ui/badge';
// import { IndianRupee, TrendingUp, TrendingDown } from 'lucide-react';
// import { toast } from 'sonner';
// import LogDateFilter from 'components/common/LogDateFilter';
// import DataTable from 'components/common/DataTable';
// import { Loader2 } from 'lucide-react';

// const ExpenseCollectionReportPage = () => {
//   const dispatch = useDispatch();

//   const {
//     expenseCollectionReport = { data: { summary: {}, results: [] }, pagination: null },
//     isLoading,
//     error,
//   } = useSelector((state) => state.report);

//   const summary = expenseCollectionReport.data.summary || {};
//   const results = expenseCollectionReport.data.results || [];
//   const pagination = expenseCollectionReport.pagination || {};

//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [dateFilters, setDateFilters] = useState({});

//   // Calculate total pages from server response
//   const totalPages = pagination.total_pages || 1;

//   const refetch = useCallback(() => {
//     dispatch(
//       fetchExpenseCollectionReport({
//         page,
//         page_size: pageSize,
//         search: searchTerm,
//         ...dateFilters,
//       })
//     );
//   }, [dispatch, page, pageSize, searchTerm, dateFilters]);

//   useEffect(() => {
//     refetch();
//   }, [refetch]);

//   useEffect(() => {
//     if (error) {
//       toast.error(error);
//       dispatch(clearError());
//     }
//   }, [error, dispatch]);

//   // Reset to page 1 when search term or page size changes
//   useEffect(() => {
//     setPage(1);
//   }, [searchTerm, pageSize]);

//   const columns = [
//     { accessorKey: 'period', header: 'Date / Period' },
//     {
//       accessorKey: 'collection',
//       header: 'Collection (₹)',
//       cell: ({ row }) => (
//         <span className="font-semibold text-green-600">
//           ₹{(row.original.collection || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//         </span>
//       ),
//     },
//     {
//       accessorKey: 'expense',
//       header: 'Expense (₹)',
//       cell: ({ row }) => (
//         <span className="font-semibold text-orange-600">
//           ₹{(row.original.expense || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//         </span>
//       ),
//     },
//     {
//       accessorKey: 'profit',
//       header: 'Profit / Loss (₹)',
//       cell: ({ row }) => {
//         const profit = row.original.profit || 0;
//         const isProfit = profit >= 0;
//         return (
//           <Badge variant={isProfit ? 'default' : 'destructive'} className="font-semibold">
//             {isProfit ? <TrendingUp className="h-3 w-3 mr-1" /> : <TrendingDown className="h-3 w-3 mr-1" />}
//             ₹{Math.abs(profit).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//           </Badge>
//         );
//       },
//     },
//   ];

//   return (
//     <div className="space-y-6 animate-fade-in">
//       <PageHeader
//         title="Expense vs Collection Report"
//         description="Daily breakdown of revenue collection, expenses, and net profit/loss"
//       />

//       <LogDateFilter onFilter={(f) => setDateFilters(f)} />

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">Total Collection</CardTitle>
//             <IndianRupee className="h-4 w-4 text-green-600" />
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold text-green-600">
//               ₹{(summary.total_collection || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//             </div>
//           </CardContent>
//         </Card>

//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">Total Expense</CardTitle>
//             <IndianRupee className="h-4 w-4 text-orange-600" />
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold text-orange-600">
//               ₹{(summary.total_expense || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//             </div>
//           </CardContent>
//         </Card>

//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">Net Profit / Loss</CardTitle>
//             {(summary.total_profit || 0) >= 0 ? (
//               <TrendingUp className="h-4 w-4 text-green-600" />
//             ) : (
//               <TrendingDown className="h-4 w-4 text-destructive" />
//             )}
//           </CardHeader>
//           <CardContent>
//             <div
//               className={`text-2xl font-bold ${(summary.total_profit || 0) >= 0 ? 'text-green-600' : 'text-destructive'}`}
//             >
//               ₹{Math.abs(summary.total_profit || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
//             </div>
//           </CardContent>
//         </Card>
//       </div>

//       {isLoading && results.length === 0 ? (
//         <div className="flex items-center justify-center py-20">
//           <Loader2 className="h-10 w-10 animate-spin mr-3" />
//           <span className="text-lg">Loading expense & collection data...</span>
//         </div>
//       ) : (
//         <DataTable
//           data={results} // Use the paginated results from the server
//           columns={columns}
//           searchPlaceholder="Search by date/period..."
//           onSearch={setSearchTerm}
//           showSearch={true}
//           pageIndex={page - 1} // Convert to 0-based index for DataTable
//           pageSize={pageSize}
//           pageCount={totalPages} // Use total pages from server response
//           onPageChange={(p) => setPage(p + 1)} // Convert back to 1-based index
//           onPageSizeChange={(newSize) => setPageSize(newSize)}
//           isLoading={isLoading}
//           onExport={() =>
//             dispatch(exportExpenseCollectionReport({ filters: { ...dateFilters, search: searchTerm } }))
//           }
//           showExport={true}
//           showImport={false}
//         />
//       )}
//     </div>
//   );
// };

// export default ExpenseCollectionReportPage;


// src/pages/modules/ExpenseCollectionReportPage.jsx

import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchExpenseCollectionReport,
  exportExpenseCollectionReport,
  clearError,
} from 'store/slices/reportSlice';

import PageHeader from 'components/common/PageHeader';
import { Card, CardHeader, CardTitle, CardContent } from 'components/ui/card';
import { Badge } from 'components/ui/badge';
import { Button } from 'components/ui/button';
import { Label } from 'components/ui/label';
import { Input } from 'components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select';
import { IndianRupee, TrendingUp, TrendingDown, Filter, X, ChevronDown, ChevronUp } from 'lucide-react';
import { toast } from 'sonner';
import LogDateFilter from 'components/common/LogDateFilter';
import DataTable from 'components/common/DataTable';
import { Loader2 } from 'lucide-react';
import { format } from 'date-fns';

const ExpenseCollectionReportPage = () => {
  const dispatch = useDispatch();

  const {
    expenseCollectionReport = { data: { summary: {}, results: [] }, pagination: null },
    isLoading,
    error,
  } = useSelector((state) => state.report);

  const summary = expenseCollectionReport.data.summary || {};
  const results = expenseCollectionReport.data.results || [];
  const pagination = expenseCollectionReport.pagination || {};

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilters, setDateFilters] = useState({});
  const [isAdvancedFilterExpanded, setIsAdvancedFilterExpanded] = useState(false);
  
  // Advanced filter states
  const [advancedFilters, setAdvancedFilters] = useState({
    // group_by: 'day',
    min_profit: '',
    max_profit: '',
  });

  // Calculate total pages from server response
  const totalPages = pagination.total_pages || 1;

  // Check if any advanced filters are active (excluding 'all' values)
  const hasActiveAdvancedFilters = Object.values(advancedFilters).some(value => 
    value !== '' && value !== 'all'
  );

  const refetch = useCallback(() => {
    // Build the API params object with all filters
    const apiParams = {
      page,
      page_size: pageSize,
      search: searchTerm,
      report_type: 'expense_collection',
      group_by: advancedFilters.group_by,
      ...dateFilters,
      // Add advanced filters with proper naming for the backend
      ...(advancedFilters.min_profit && { min_profit: advancedFilters.min_profit }),
      ...(advancedFilters.max_profit && { max_profit: advancedFilters.max_profit }),
    };
    
    
    dispatch(fetchExpenseCollectionReport(apiParams));
  }, [dispatch, page, pageSize, searchTerm, dateFilters, advancedFilters]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
    }
  }, [error, dispatch]);

  // Reset to page 1 when search term, page size, or filters change
  useEffect(() => {
    setPage(1);
  }, [searchTerm, pageSize, dateFilters, advancedFilters]);

  // --- Event Handlers ---
  const handleAdvancedFilterChange = (key, value) => {
    setAdvancedFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetAdvancedFilters = () => {
    setAdvancedFilters({
      // group_by: 'day',
      min_profit: '',
      max_profit: '',
    });
  };

  const columns = [
    { 
      accessorKey: 'period', 
      header: 'Date / Period',
      cell: ({ row }) => {
        const date = row.original.period;
        return (
          <span className="font-medium">
            {date ? format(new Date(date), 'dd MMM yyyy') : '-'}
          </span>
        );
      }
    },
    {
      accessorKey: 'collection',
      header: 'Collection (₹)',
      cell: ({ row }) => (
        <span className="font-semibold text-green-600">
          ₹{(row.original.collection || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </span>
      ),
    },
    {
      accessorKey: 'expense',
      header: 'Expense (₹)',
      cell: ({ row }) => (
        <span className="font-semibold text-orange-600">
          ₹{(row.original.expense || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </span>
      ),
    },
    {
      accessorKey: 'profit',
      header: 'Profit / Loss (₹)',
      cell: ({ row }) => {
        const profit = row.original.profit || 0;
        const isProfit = profit >= 0;
        return (
          <Badge variant={isProfit ? 'default' : 'destructive'} className="font-semibold">
            {isProfit ? <TrendingUp className="h-3 w-3 mr-1" /> : <TrendingDown className="h-3 w-3 mr-1" />}
            ₹{Math.abs(profit).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
          </Badge>
        );
      },
    },
  ];

  return (
    <div className="space-y-6 animate-fade-in">
      <PageHeader
        title="Expense vs Collection Report"
        description="Daily breakdown of revenue collection, expenses, and net profit/loss"
      />

      <LogDateFilter onFilter={(f) => setDateFilters(f)} />

      {/* Advanced Filters Card */}
      <Card>
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <CardTitle className="text-lg flex items-center gap-2">
              <Filter className="h-5 w-5" />
              Advanced Filters
              {hasActiveAdvancedFilters && (
                <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                  Active
                </span>
              )}
            </CardTitle>
            <div className="flex gap-2">
              {hasActiveAdvancedFilters && (
                <Button variant="outline" size="sm" onClick={resetAdvancedFilters}>
                  <X className="h-4 w-4 mr-1" />
                  Reset
                </Button>
              )}
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={() => setIsAdvancedFilterExpanded(!isAdvancedFilterExpanded)}
              >
                {isAdvancedFilterExpanded ? (
                  <>
                    Hide <ChevronUp className="h-4 w-4 ml-1" />
                  </>
                ) : (
                  <>
                    Show <ChevronDown className="h-4 w-4 ml-1" />
                  </>
                )}
              </Button>
            </div>
          </div>
        </CardHeader>
        {isAdvancedFilterExpanded && (
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {/* <div className="space-y-2">
                <Label htmlFor="group_by">Group By</Label>
                <Select
                  value={advancedFilters.group_by}
                  onValueChange={(value) => handleAdvancedFilterChange('group_by', value)}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select grouping" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="day">Day</SelectItem>
                    <SelectItem value="month">Month</SelectItem>
                  </SelectContent>
                </Select>
              </div> */}
              
              <div className="space-y-2">
                <Label>Profit Range (₹)</Label>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <Input
                      type="number"
                      placeholder="Min"
                      value={advancedFilters.min_profit}
                      onChange={(e) => handleAdvancedFilterChange('min_profit', e.target.value)}
                    />
                  </div>
                  <div>
                    <Input
                      type="number"
                      placeholder="Max"
                      value={advancedFilters.max_profit}
                      onChange={(e) => handleAdvancedFilterChange('max_profit', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        )}
      </Card>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Collection</CardTitle>
            <IndianRupee className="h-4 w-4 text-green-600" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600">
              ₹{(summary.total_collection || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Expense</CardTitle>
            <IndianRupee className="h-4 w-4 text-orange-600" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-orange-600">
              ₹{(summary.total_expense || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Net Profit / Loss</CardTitle>
            {(summary.total_profit || 0) >= 0 ? (
              <TrendingUp className="h-4 w-4 text-green-600" />
            ) : (
              <TrendingDown className="h-4 w-4 text-destructive" />
            )}
          </CardHeader>
          <CardContent>
            <div
              className={`text-2xl font-bold ${(summary.total_profit || 0) >= 0 ? 'text-green-600' : 'text-destructive'}`}
            >
              ₹{Math.abs(summary.total_profit || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* {isLoading && results.length === 0 ? (
        <div className="flex items-center justify-center py-20">
          <Loader2 className="h-10 w-10 animate-spin mr-3" />
          <span className="text-lg">Loading expense & collection data...</span>
        </div>
      ) : ( */}
        <DataTable
          data={results} // Use paginated results from the server
          columns={columns}
          totalCount={pagination.count}
          searchPlaceholder="Search by date/period..."
          onSearch={setSearchTerm}
          showSearch={false}
          pageIndex={page - 1} // Convert to 0-based index for DataTable
          pageSize={pageSize}
          pageCount={totalPages} // Use total pages from server response
          onPageChange={(p) => setPage(p + 1)} // Convert back to 1-based index
          onPageSizeChange={(newSize) => setPageSize(newSize)}
          isLoading={isLoading}
          onExport={() =>
            dispatch(exportExpenseCollectionReport({ 
              filters: { 
                page,
                page_size: pageSize,
                search: searchTerm,
                report_type: 'expense_collection',
                group_by: advancedFilters.group_by,
                ...dateFilters,
                // Include advanced filters in export
                ...(advancedFilters.min_profit && { min_profit: advancedFilters.min_profit }),
                ...(advancedFilters.max_profit && { max_profit: advancedFilters.max_profit }),
              } 
            }))
          }
          showExport={true}
          showImport={false}
        />
      {/* )} */}
    </div>
  );
};

export default ExpenseCollectionReportPage;